/**
 * External dependencies
 */
import page from 'page';

/**
 * Internal dependencies
 */

import * as controller from 'lib/controller';
import { pathToRegExp } from "./utils";
import { receiveSections, load } from './sections-helper';
import { setSection } from 'state/ui/actions';
import { redirectLoggedOut } from 'lib/controller/utils';
import sections from './sections';
receiveSections( sections );



/**
 * Cache of already loaded or loading section modules. Every section module is in one of
 * three states regarding the cache:
 * - no record in the cache: not loaded or not currently loading
 * - record value is `true`: already loaded and initialized
 * - record value is a `Promise`: is currently loading, the promise will fulfill when done.
 *   Don't start a second load with `loadSection` but rather wait for the existing promise.
 */
const _loadedSections = {};


/**
 * [description]
 * @param  {[type]} sectionDefinition [description]
 * @param  {[type]} context           [description]
 * @return {[type]}                   [description]
 */
const activateSection = (sectionDefinition, context) => {
    context.store.dispatch(setSection(sectionDefinition));
}

/**
 * [description]
 * @param  {[type]} path              [description]
 * @param  {[type]} sectionDefinition [description]
 * @return {[type]}                   [description]
 */
const createPageDefinition = ( path, sectionDefinition ) => {
    
    const pathRegex = pathToRegExp( path );

    // check if the route definition supports being logged out
    
    if (!sectionDefinition.enableLoggedOut) { 
        page(pathRegex, redirectLoggedOut);
    }

    page( pathRegex, async function( context, next ) {

        try {
            const loadedSection = _loadedSections[ sectionDefinition.module ];

            if ( loadedSection ) {
                // wait for the promise if loading, do nothing when already loaded
                if ( loadedSection !== true ) {
                    await loadedSection;
                }
            } else {
                // start loading the section and record the `Promise` in a map
                const loadingSection = loadSection( context, sectionDefinition );
                _loadedSections[ sectionDefinition.module ] = loadingSection;

                // wait until the section module is loaded and the set the map record to `true`
                await loadingSection;
                _loadedSections[ sectionDefinition.module ] = true;
            }

            // activate the section after ensuring it's fully loaded
			activateSection( sectionDefinition, context );
			next();
        } catch (error){
        	console.log(error);
        }
    });

}

/**
 * [description]
 * @param  {[type]} context           [description]
 * @param  {[type]} sectionDefinition [description]
 * @return {[type]}                   [description]
 */
const loadSection = async ( context, sectionDefinition ) => {
    context.store.dispatch( { type: 'SECTION_SET', isLoading: true } );
    try {
        // load the section module, i.e., its webpack chunk
        const requiredModule = await load( sectionDefinition.name, sectionDefinition.module );
        
        // call the module initialization function
        await requiredModule.default( controller.clientRouter );
    } finally {
        context.store.dispatch( { type: 'SECTION_SET', isLoading: false } );
    }
}

/**
 * [description]
 * @return {[type]} [description]
 */
export const setupRoutes = () => {
    for ( const section of sections ) {
        for ( const path of section.paths ) {
            createPageDefinition( path, section );
        }
    }
};

